import React from 'react';

import { mosaiqStyled } from '../../lib';

import { ButtonProps } from './types';

import { ButtonContainer } from './Button.styles';

const Button = mosaiqStyled<ButtonProps, HTMLButtonElement>(
  ({ children, endAdornment, startAdornment, innerRef, href, ...props }) => {
    const isExternal =
      href?.startsWith('http') || href?.startsWith('mailto') || href?.startsWith('tel');

    const buttonProps = {
      href,
      rel: href && isExternal ? 'noopener noreferrer' : undefined,
      type: href ? undefined : ('button' as HTMLButtonElement['type']),
    };

    return (
      <ButtonContainer
        ref={innerRef}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        as={href ? 'a' : 'button'}
        {...buttonProps}
        {...props}
      >
        {startAdornment}
        <span>{children}</span>
        {endAdornment}
      </ButtonContainer>
    );
  },
);

Button.displayName = 'Button';

export default Button;
